;(function (){
    if(!navigator?.serviceWorker){
        console.error('Service Worker is not supported in this browser')
        return;
    }
    navigator.serviceWorker.addEventListener('message', async (event) => {
        try {
            await BX.ajax.runAction('sotbit:notification.PWA.readNotice', {
                data: {id: event.data.id},
            });
        } catch (error) {
            console.error('Error handling service worker message:', error);
        }
    });
})()
